import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Comparison Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Compare algorithm-generated routes with manually planned routes to evaluate efficiency and identify optimization opportunities. This mode provides detailed analysis of both routing solutions.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>At least one path created in Auto Find Path Mode</li>
            <li>At least one path created in Custom Path Mode</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Create Both Paths:</strong>
              <ul>
                <li>Go to Auto Find Path Mode and generate a solution</li>
                <li>Go to Custom Path Mode and create your own route</li>
                <li>Both paths will be stored automatically</li>
              </ul>
            </li>
            <li><strong>View Comparison:</strong>
              <ul>
                <li>Switch to Comparison Mode</li>
                <li>Both paths are displayed on the map:
                  <ul>
                    <li><strong style={{color: '#4285F4'}}>Blue route:</strong> Auto-generated path</li>
                    <li><strong style={{color: '#FF5722'}}>Orange route:</strong> Custom manual path</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li><strong>Review Path Information:</strong>
              <ul>
                <li><strong>Auto Path (Algorithm Solution):</strong>
                  <ul>
                    <li>Total duration</li>
                    <li>Number of points</li>
                    <li>Route sequence</li>
                  </ul>
                </li>
                <li><strong>Custom Path (Manual Planning):</strong>
                  <ul>
                    <li>Total duration</li>
                    <li>Number of points</li>
                    <li>Route sequence</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li><strong>Analyze Comparison Results:</strong>
              <ul>
                <li><strong>Time Difference:</strong> Shows saved or added hours</li>
                <li><strong>Conclusion:</strong> Which path is more efficient</li>
                <li><strong>Detailed Comparison:</strong> Click "Show Detailed Comparison"
                  <ul>
                    <li>Segment-by-segment breakdown</li>
                    <li>Duration comparison table</li>
                    <li>Optimization suggestions</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>

          <p><strong>Comparison Metrics:</strong></p>
          <ul>
            <li><strong>Total Duration:</strong> End-to-end travel time (hours)</li>
            <li><strong>Point Count:</strong> Number of locations visited</li>
            <li><strong>Time Difference:</strong> Absolute and percentage difference</li>
            <li><strong>Efficiency Rating:</strong> Which solution performs better</li>
          </ul>

          <p><strong>Interpretation:</strong></p>
          <ul>
            <li><strong>Green "Saved X hours":</strong> Custom path is faster (good manual planning!)</li>
            <li><strong>Red "Added X hours":</strong> Auto path is faster (algorithm found better route)</li>
            <li><strong>"Negligible":</strong> Both paths have similar performance (&lt;5% difference)</li>
          </ul>

          <p><strong>Use Cases:</strong></p>
          <ul>
            <li>Validate algorithm-generated solutions against expert knowledge</li>
            <li>Identify opportunities for route optimization</li>
            <li>Learn from algorithm suggestions to improve manual planning</li>
            <li>Evaluate trade-offs between different routing strategies</li>
            <li>Make data-driven decisions for transport planning</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Both paths must be created before comparison is available</li>
            <li>Comparison considers capacity constraints if demand &gt; 0</li>
            <li>Use detailed comparison to understand specific differences</li>
            <li>Try different custom routes to find improvements</li>
            <li>Algorithm solutions are optimized but may miss domain-specific constraints</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 